import * as Yup from "yup";

export const SavePhNumberSchema = Yup.object().shape({
  phoneNumber: Yup.string()
    .required("Please enter your phone number")
    .matches(/^[0-9]+$/, "Must be only digits")
    .test("len", "Must be exactly 10 digits", (val) => val?.length === 10),
});
